import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SecureBaseStore from "./SecureBaseStore";

class AdvertisementState {
    constructor(
        loadingState,
        advertisement
    ) {
        this.loadingState = loadingState;
        this.advertisement = advertisement;
    }

    equals(other) {
        return this.loadingState === other.loadingState &&
            this.advertisement.advertisementId === other.advertisement.advertisementId &&
            this.advertisement.memberId === other.advertisement.memberId &&
            this.advertisement.title === other.advertisement.title &&
            this.advertisement.description === other.advertisement.description &&
            this.advertisement.statusId === other.advertisement.statusId &&
            this.advertisement.statusName === other.advertisement.statusName &&
            this.advertisement.created === other.advertisement.created &&
            this.advertisement.updated === other.advertisement.updated &&
            this.advertisement.deleted === other.advertisement.deleted &&
            this.advertisement.imageNames === other.advertisement.imageNames;
    }
}

class ImmutableAdvertisementStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
        this.advertisement = {};
    }

    static fromState(state) {
        return new ImmutableAdvertisementStateBuilder()
            .setLoadingState(state.loadingState)
            .setAdvertisement(state.advertisement);
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }

    setAdvertisement(advertisement) {
        this.advertisement = advertisement;
        return this;
    }

    build() {
        return Object.freeze(new AdvertisementState(this.loadingState, this.advertisement));
    }
}


class AdvertisementDetailsStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.ADVERTISEMENT_STORE_UPDATE, ImmutableAdvertisementStateBuilder);
        this.subscribeToEvent(ActionResultEvents.ADVERTISEMENT_LOADED, this.handleAdvertisementLoaded);
        this.subscribeToEvent(UIInteractionEvents.PRIVATE_ADVERTISEMENT_PREVIEW_VIEW_MOUNTED, this.resetStore);
    }

    handleAdvertisementLoaded = (topic, data) => {
        return ImmutableAdvertisementStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .setAdvertisement(data)
            .build();
    };

}

export default new AdvertisementDetailsStore();